module.exports = "/images/QcompetitorLogoStrategic.png?93ffd10d3cba5fe7ae4ff0564d6a4faa";